import { withContextFactory } from "../../contexts/contexts.utils";
import { DialogContext, IDialogContext } from "./Dialog";

export interface WithDialogContext {
    dialogContext: IDialogContext;
}

export const withDialogContext = withContextFactory<WithDialogContext>(DialogContext, "dialogContext");
